<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 23.5">
		<path fill="currentColor" fill-rule="evenodd" d="M11.75 1.5A10.25 10.25 0 1 0 22 11.75 10.25 10.25 0 0 0 11.75 1.5ZM0 11.75A11.75 11.75 0 1 1 11.75 23.5 11.75 11.75 0 0 1 0 11.75Z"/>
		<path fill-rule="evenodd" d="M11.75 10.75a.75.75 0 0 1 .75.75V17a.75.75 0 0 1-1.5 0v-5.5a.75.75 0 0 1 .75-.75Z"/>
		<path fill-rule="evenodd" d="M11.75 4.75a.75.75 0 0 1 .75.75V7A.75.75 0 0 1 11 7V5.5a.75.75 0 0 1 .75-.75Z"/>
	</svg>
</template>
